import 'globalStyles/theme.scss';
import { EventEmitter } from '@firenet-designs/shopify-common'

EventEmitter.polyfill();
import ThemeService from './services/ThemeService';


const initializeApp = (settings) => {
  try {
    settings.discountLength = settings.discountLength * 60 * 1000; // converting min --> ms
    settings.discountFlat = parseInt(settings.discountFlat);
    settings.delimiter = '~~';
    Object.freeze(settings); // Locking in as read-only.
    new ThemeService(settings);
  }
  catch(e){
    console.error("Malformed Liquid Settings, cannot initialize bold.theme.bundle.js", e);
  }
};


const FND = (window.FND = window.FND || {});
FND.BUILDS = FND.BUILDS || {};
FND.BUILDS.Theme = FND.BUILDS.Theme || {};
FND.BUILDS.Theme.initializeFunnelApp = initializeApp;